<template>
    <div> 
        <link href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css" rel="stylesheet">       
        <div class="row">   

            <div style="width: 70%;">
                <div class="col-xs-12 col-md-12 offset-md-2 block">
                    <div class="wrapper-progressBar">
                        <ul class="progressBar">
                            <li class="active">Añade Tu Plataforma</li>
                            <li class="active">Añade Tus Canales</li>
                            <li class="active">Selecciona un Video</li>
                            <li class="active">¡Genera Tus Ideas!</li>
                        </ul>
                    </div>
                </div>
            </div>
                    
            <div class="jumbotron bg-light" style="width: 100%; margin-top: 10px;">

                <router-link style="margin-top: -60px;" :to="/listado_post/+$route.params.usuario" class="btn btn-outline-dark"><span class="mdi mdi-keyboard-return"></span> Regresar a la selección de videos</router-link>                                                     
                <div>                    
                    <div v-if="comentarios.length > 0" class="row">                                                                        

                        <div class="container-fluid py-2 bg-light">
                            <b-row class="mb-5">
                                <b-col lg="12">
                                    <div class="video-section p-4 bg-white rounded shadow-sm">
                                    <b-row>
                                        <b-col md="6">
                                        <div class="embed-responsive embed-responsive-16by9 mb-4">
                                            <iframe 
                                                width="560" 
                                                height="315" 
                                                :src="posts[0].url" 
                                                :title="posts[0].titulo" 
                                                frameborder="0" 
                                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                                                referrerpolicy="strict-origin-when-cross-origin" 
                                                allowfullscreen>
                                            </iframe>
                                        </div>
                                        </b-col>
                                        <b-col md="6">
                                        <h3 class="mb-3">{{ posts[0].titulo }}</h3>
                                        <p class="mb-4 text-muted">{{ posts[0].descripcion }}</p>
                                        <div class="d-flex justify-content-between align-items-center">
                                            <div class="d-flex align-items-center">
                                            <ThumbsUp class="mr-2 text-purple" />
                                            <span class="mr-4"><span class="mdi mdi-heart"></span>100 Me Gustas</span>
                                            <MessageSquare class="mr-2 text-purple" />
                                            <span><span class="mdi mdi-forum"></span> 50 Comentarios</span>
                                            </div>
                                            <b-button variant="outline-purple" size="sm"><span class="mdi mdi-share-variant"></span> Compartir</b-button>
                                        </div>
                                        </b-col>
                                    </b-row>
                                    </div>
                                </b-col>
                            </b-row>

                            <b-row>
                                
                                <b-col lg="12">
                                    <div class="ideas-list p-4 bg-white rounded shadow-sm">
                                        <h3 class="mb-4 text-purple">Ideas Generadas</h3>
                              
                                        <div class="row">
                                            
                                            <div class="col">
                                                <h2 class="section-title">
                                                    <i class="fas fa-video icon-purple"></i>
                                                    Próximos Videos
                                                </h2>
                                                <ul class="list-group" v-for="prox_videos in ideas_posts.ideas_proximos_videos" v-bind:key="prox_videos">
                                                    <li class="list-group-item"><i class="fas fa-lightbulb icon-purple"></i>{{ prox_videos }}</li>
                                                </ul>
                                            </div>

                                            <div class="col">
                                                <h2 class="section-title">
                                                    <i class="fas fa-tasks icon-purple"></i>
                                                    Pasos Desarrollar Ideas
                                                </h2>
                                                
                                                <ul class="list-group" v-for="pasos in ideas_posts.pasos_desarrollar_ideas" v-bind:key="pasos">
                                                    <li class="list-group-item"><i class="fas fa-check-circle icon-purple"></i>{{ pasos }}</li>
                                                </ul>
                                            </div>
                                            
                                        </div>

                                        <div class="row">
                                            
                                            <div class="col">
                                                <h2 class="section-title">
                                                    <i class="fas fa-comments icon-purple"></i>
                                                    Feedback
                                                </h2>
                                                <div class="feedback-container">
                                                    <div class="feedback-col">
                                                        <h3 class="text-success"><i class="fas fa-plus-circle icon-purple"></i>Positivo</h3>
                                                        <ul class="list-group" v-for="positivo in ideas_posts.feedback.positivos" v-bind:key="positivo">
                                                            <li class="list-group-item"><i class="fas fa-thumbs-up icon-purple"></i>{{positivo}}</li>
                                                        </ul>
                                                    </div>
                                                    <div class="feedback-col">
                                                        <h3 class="text-danger"><i class="fas fa-minus-circle icon-purple"></i>Negativo</h3>
                                                        <ul class="list-group" v-for="negativo in ideas_posts.feedback.negativos" v-bind:key="negativo">
                                                            <li class="list-group-item"><i class="fas fa-thumbs-down icon-purple"></i>{{ negativo }}</li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col">
                                                <h2 class="section-title">
                                                    <i class="fas fa-box icon-purple"></i>
                                                    Ideas de Productos
                                                </h2>
                                                <ul class="list-group" v-for="producto in ideas_posts.ideas_productos" v-bind:key="producto">
                                                    <li class="list-group-item"><i class="fas fa-star icon-purple"></i>{{ producto }}</li>
                                                </ul>
                                            </div>
                
                                        </div>

                                    </div>
                                </b-col>
                            </b-row>

                            <b-row>
                                <b-col lg="12" class="mb-4">
                                    <div class="idea-generator p-4 bg-white rounded shadow-sm">
                                        <h2 class="mb-4 text-purple">Comentarios de YouTube</h2>
                                        
                                        <ul class="comments-list" v-for="comentario in comentarios_posts" v-bind:key="comentario">
                                            <li class="comment">
                                                <div class="comment-avatar">
                                                    <img :src="comentario.snippet.topLevelComment.snippet.authorProfileImageUrl" alt="Avatar de Usuario 1">
                                                </div>
                                                <div class="comment-content">
                                                    <div class="comment-author">{{ comentario.snippet.topLevelComment.snippet.authorDisplayName }}</div>
                                                    <p class="comment-text">{{ comentario.snippet.topLevelComment.snippet.textDisplay }}</p>
                                                </div>
                                            </li>                                           
                                        </ul>

                                    </div>
                                </b-col>                                
                            </b-row>

                        </div>

                    </div>
                    <div class="card" v-else>
                        <div class="card-body">
                            <button class="btn btn-success" type="button" disabled v-if="loading">
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                ¡Generando Ideas para este Posts! :)
                            </button>                                                           
                        </div>
                    </div>                    

                </div>

            </div>  
            
        </div>        
    </div>
</template>
<script>

import {headers} from './../../api/headers'
import {configApi} from './../../api/configApi'

export default {
    name: 'dashboard',
    data: () => ({        
        comentarios: [],  
        comentarios_posts: [], 
        posts: [],
        data: [],
        ideas_posts: [],
        loading: true
    }),
    mounted() {
        this.getComentarios()
        this.getDatosPosts()
        this.getIdeasGeneradas()
        this.getComentariosPosts()
    },
    methods: {
        async getDatosPosts() {
            return await this.axios.get(configApi+'listado_posts/'+this.$route.params.idPosts, {headers})
            .then(response => {
                this.posts = response.data.data;
            })
        },
        async getComentarios() {

            return await this.axios.get(configApi+'comentarios_posts_videos/'+this.$route.params.videoId+'/'+this.$route.params.idPosts, {headers})
            .then(response => {
                this.comentarios = response.data.data;
            })

        },    
        async getComentariosPosts() {

            return await this.axios.get(configApi+'obtener_comentarios_posts/'+this.$route.params.videoId+'/'+this.$route.params.idPosts, {headers})
            .then(response => {
                console.log(response)
                this.comentarios_posts = response.data.data;
            })

        },    
        async getIdeasGeneradas() {
            
            return await this.axios.get(configApi+'generador_ideas/'+this.$route.params.idPosts, {headers})
            .then(response => {
                this.ideas_posts = JSON.parse(response.data.data[0].salida_texto)
                
                this.loading = false 
                // this.$Fun.alertaAccion('success', response.data.message, false)
            })

        },
        navegacion(menu, videoId) {
            this.$router.push('/'+menu+'/'+videoId)
        },
    }
}
</script>
<style>
.text-purple {
  color: #6f42c1;
}

.btn-outline-purple {
  color: #6f42c1;
  border-color: #6f42c1;
}

.btn-outline-purple:hover, .btn-outline-purple:focus, .btn-outline-purple:active {
  color: #fff;
  background-color: #6f42c1;
  border-color: #6f42c1;
}

.shadow-sm {
  box-shadow: 0 .125rem .25rem rgba(0,0,0,.075)!important;
}

.bg-light {
  background-color: #f8f9fa!important;
}

h2, h3, h5 {
  font-weight: 600;
}

.badge {
  font-weight: 500;
}

.idea-card {
  transition: all 0.3s ease;
  border: 1px solid rgba(0,0,0,.125);
}

.idea-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 .5rem 1rem rgba(0,0,0,.15)!important;
}

@media (max-width: 767.98px) {
  .video-section .row {
    flex-direction: column;
  }
}

.wrapper-progressBar {
    width: 100%;
}

.progressBar li {
    list-style-type: none;
    float: left;
    width: 25%;
    position: relative;
    text-align: center;
}

.progressBar li:before {
    content: " ";
    line-height: 30px;
    border-radius: 50%;
    width: 30px;
    height: 30px;
    border: 1px solid #ddd;
    display: block;
    text-align: center;
    margin: 0 auto 10px;
    background-color: white
}

.progressBar li:after {
    content: "";
    position: absolute;
    width: 100%;
    height: 4px;
    background-color: #ddd;
    top: 15px;
    left: -50%;
    z-index: -1;
}

.progressBar li:first-child:after {
    content: none;
}

.progressBar li.active {
    color: dodgerblue;
}

.progressBar li.active:before {
    border-color: dodgerblue;
    background-color: dodgerblue
}

.progressBar .active:after {
    background-color: dodgerblue;
}

.col {
    flex: 1;
    padding: 10px;
    min-width: 300px;
}
.section-title {
    color: #6f42c1;
    border-bottom: 2px solid #6f42c1;
    padding-bottom: 10px;
    margin-bottom: 20px;
}
.list-group {
    list-style-type: none;
    border: none;
}
.list-group-item {
    padding: 10px 0;
    border: none !important;
}
.icon-purple {
    color: #6f42c1;
    margin-right: 10px;
}
.text-success {
    color: #28a745;
}
.text-danger {
    color: #dc3545;
}
.feedback-container {
    display: flex;
    flex-wrap: wrap;
    margin: -10px;
}
.feedback-col {
    flex: 1;
    padding: 10px;
    min-width: 200px;
}
@media (max-width: 768px) {
    .col, .feedback-col {
        flex: 100%;
    }
}

.comments-list {
    list-style-type: none;
}

.comment {
    display: flex;
    background-color: #fff;
    border-radius: 8px;
    padding: 15px;
    margin-bottom: 20px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    transition: box-shadow 0.3s ease;
}

.comment:hover {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.comment-avatar {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    margin-right: 15px;
    overflow: hidden;
}

.comment-avatar img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.comment-content {
    flex: 1;
}

.comment-author {
    font-weight: bold;
    color: var(--purple);
    margin-bottom: 5px;
}

.comment-text {
    font-size: 14px;
    line-height: 1.4;
}

@media (max-width: 600px) {
    .comment {
        flex-direction: column;
    }

    .comment-avatar {
        margin-right: 0;
        margin-bottom: 10px;
    }
}
</style>